import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const EuclidAmsIcon: React.FC<IconProps> = (props) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg" width="65" height="68" viewBox="0 0 65 68" fill="none" {...props} >
    <circle cx="32" cy="34" r="32" fill="#89BC30" />
    <g filter="url(#filter0_d_1613_2824)">
      <path d="M32.16 20.36C29.52 20.36 27.4667 21.1867 26 22.84C24.56 24.4933 23.6534 26.7333 23.28 29.56H41C40.8134 26.5467 39.8934 24.2667 38.24 22.72C36.6134 21.1467 34.5867 20.36 32.16 20.36ZM32.16 10.96C35.7867 10.96 39.0534 11.64 41.96 13C44.8667 14.36 47.2667 16.5067 49.16 19.44C50.8667 22.0267 51.9734 25.0267 52.48 28.44C52.7734 30.44 52.8934 33.32 52.84 37.08H23C23.16 41.4533 24.5334 44.52 27.12 46.28C28.6934 47.3733 30.5867 47.92 32.8 47.92C35.1467 47.92 37.0534 47.2533 38.52 45.92C39.32 45.2 40.0267 44.2 40.64 42.92H52.28C51.9867 45.5067 50.64 48.1333 48.24 50.8C44.5067 55.04 39.28 57.16 32.56 57.16C27.0134 57.16 22.12 55.3733 17.88 51.8C13.64 48.2267 11.52 42.4133 11.52 34.36C11.52 26.8133 13.4267 21.0267 17.24 17C21.08 12.9733 26.0534 10.96 32.16 10.96Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_1613_2824" x="3.52002" y="0.959991" width="61.3325" height="66.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1613_2824" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1613_2824" result="shape" />
      </filter>
    </defs>

  </Icon>
);




